module.exports = __webpack_public_path__ + "img/ornament-844.3a6b6e31.png";